import { useI18n } from 'vue-i18n';
import { useConfirm } from '@lumi/app-kit';

// Leaving the owner's own details unfilled is allowed, but never silently: both
// places that ask for them (the setup wizard's first step and the prompt on Suite
// Home) route a skip through this one warning, so they cannot drift apart on what
// staying unconfirmed means (ADR 0088 R5).
//
// Resolves true when the owner deliberately skips, false when they choose to fill
// the details in now. "Fill in now" is the primary action; Escape or a dismissed
// dialog counts as the explicit skip, since the dialog offers no third answer.
export function useOwnDetailsSkipWarning() {
  const { t } = useI18n();
  const { confirm } = useConfirm();

  async function confirmSkip(): Promise<boolean> {
    const fillNow = await confirm({
      title: t('homebase.ownDetails.skip.title'),
      body: t('homebase.ownDetails.skip.body'),
      variant: 'warning',
      confirmLabel: t('homebase.ownDetails.skip.fill'),
      cancelLabel: t('homebase.ownDetails.skip.skip'),
    });
    return !fillNow;
  }

  return { confirmSkip };
}
